import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_COMMUNE_BY_DISTRICT } from "../Schema/SelectSchema";

export const useGetCommuneByDistrict = ({ districtMunicipalitiesId }) => {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState();

  const { refetch } = useQuery(GET_COMMUNE_BY_DISTRICT, {
    variables: {
      districtMunicipalitiesId: districtMunicipalitiesId,
    },
    onCompleted: ({ getCommuneByDistrict }) => {
     
      setTableData(getCommuneByDistrict || []);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, []);

  return { tableData, loading, refetch };
};
